import { Suspense, useEffect } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { routes } from '@routes/index'
import { PageSkeleton } from '@components/shell/PageSkeleton'
import { AppErrorBoundary } from '@components/shell/AppErrorBoundary'
import { ToastContainer } from '@components/atoms/Toast'
import { commenceRefreshTokenInterval, cancelRefreshToken } from '@services/auth'
import { initBroadcastListener } from '@services/auth/broadcast'
import { onOptimizelyReady } from '@services/optimizely'
import { isValidSession } from '@services/session'

// Data router — required for v7 data APIs like `useMatches`, which the
// shells use to read per-route metadata (title, navItem, parentPath)
// from each `RouteObject.handle`.
const router = createBrowserRouter(routes)

export default function App() {
  // Start the refresh-token interval on app boot if a session is valid;
  // tear it down on unmount so HMR doesn't stack timers.
  useEffect(() => {
    if (isValidSession()) commenceRefreshTokenInterval()
    const unsubscribe = initBroadcastListener()
    void onOptimizelyReady()
    return () => {
      cancelRefreshToken()
      unsubscribe()
    }
  }, [])

  return (
    <>
      <AppErrorBoundary>
        <Suspense fallback={<PageSkeleton />}>
          <RouterProvider router={router} />
        </Suspense>
      </AppErrorBoundary>
      <ToastContainer />
    </>
  )
}
